/**************************************************
 * Nombre:       Formulario_Carga_Imagen
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Carga_Imagen = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography sx={{textAlign: 'center'}}>{props.descripcion}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagen dato={'img'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Carga_Imagen